export const enUS = {
    //---------------- not necesary to translate
    SOMETHING : "Alguna cosa",
    PRICING: "Pricing",
    SING_IN: "Sign-in",
    HOME: "Home",
    LOGIN: 'Login',
    NAVIGATION : "Navigation",
}